import { createRouter, createWebHistory } from 'vue-router'

import { adminRoutes } from './admin/routes'
import { eventRoutes } from './event/routes'
import { organizeRoutes } from './organize/routes'
import { blockedPath, loadAppVersion } from './shared/appRole'
import { resolveRoot, rootTarget } from './shared/resolve'

// Three views, three route groups. Each group lazy-loads its own layout so the
// attendee app never downloads admin code.
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => import('./shared/Landing.vue'),
      // A host (e.g. the badge QR's bare host) opens its event; 404 or localhost shows the landing.
      beforeEnter: async (to) => {
        const v = await loadAppVersion()
        let slug = await resolveRoot()
        // An event server is pinned: the landing page is never shown there.
        if (!slug && v.role === 'event') slug = v.event_slug
        return slug ? rootTarget(slug, to.query, to.hash) : true
      },
    },
    { path: '/e/:slug', component: () => import('./event/EventApp.vue'), children: eventRoutes },
    { path: '/organize/:slug', component: () => import('./organize/OrganizeApp.vue'), children: organizeRoutes },
    { path: '/admin', component: () => import('./admin/AdminApp.vue'), children: adminRoutes },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('./shared/NotFound.vue') },
  ],
})

// An event server mounts no organizer or App Admin API: those paths are NotFound (URL kept).
router.beforeEach(async (to) => {
  if (to.name === 'not-found' || !/^\/(organize|admin)(\/|$)/.test(to.path)) return true
  const { role } = await loadAppVersion()
  if (!blockedPath(role, to.path)) return true
  return { name: 'not-found', params: { pathMatch: to.path.split('/').slice(1) }, query: to.query, hash: to.hash, replace: true }
})
